import {useSelector,useDispatch} from 'react-redux'
import {
	getLibraryExercises,
	selectLibrary,
	selectAllLibraryExercises,
} from './exerciseListSlice.js'

export const useLibraryExercises = (tgtUser)=>{
	const dispatch = useDispatch()
	const {status,tgtUser:currentTgtUser} = useSelector(selectLibrary)
	const exercises = useSelector(selectAllLibraryExercises)
	//if tgtUser is different re-fetch from the API
	if( currentTgtUser !== tgtUser ) dispatch(getLibraryExercises({tgt_user_id_number:tgtUser}))
	return {status,exercises}
}